export function isNoSpecialCharacters(value) {
    return /^[a-zA-Z0-9]*$/.test(value || '');
}
